// Status indicator icons will be moved here by the user
// Examples: WarningIcon, GreenCheckmarkFilledIcon, ConsistentIcon, etc.

import { cn } from '@ui/lib/utils';
import { FC, SVGProps } from 'react';
export const WarningIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={22}
    viewBox="0 0 24 22"
    fill="none"
    {...props}
  >
    <path
      d="M23.545 16.8524L14.8144 1.66872C14.5322 1.16279 14.12 0.741383 13.6205 0.448025C13.121 0.154668 12.5522 0 11.9729 0C11.3936 0 10.8248 0.154668 10.3252 0.448025C9.8257 0.741383 9.41354 1.16279 9.13135 1.66872L0.454987 16.8524C0.163023 17.3448 0.0061395 17.9055 0.000176565 18.4779C-0.00578637 19.0503 0.139382 19.6142 0.421025 20.1126C0.702668 20.6109 1.11082 21.0262 1.60426 21.3164C2.09771 21.6066 2.65898 21.7614 3.23142 21.7653H20.7143C21.2913 21.771 21.8595 21.6231 22.3605 21.3369C22.8616 21.0506 23.2775 20.6362 23.5656 20.1362C23.8536 19.6362 24.0036 19.0685 23.9999 18.4915C23.9963 17.9144 23.8393 17.3487 23.545 16.8524Z"
      fill="#D97706"
    />
    <path
      d="M12.0295 15.4686C11.7823 15.4686 11.5406 15.5419 11.3351 15.6793C11.1295 15.8166 10.9693 16.0119 10.8747 16.2403C10.7801 16.4687 10.7553 16.72 10.8036 16.9625C10.8518 17.205 10.9708 17.4277 11.1457 17.6025C11.3205 17.7773 11.5432 17.8964 11.7857 17.9446C12.0282 17.9928 12.2795 17.9681 12.5079 17.8735C12.7363 17.7789 12.9315 17.6187 13.0689 17.4131C13.2062 17.2075 13.2795 16.9659 13.2795 16.7186C13.2795 16.3871 13.1478 16.0692 12.9134 15.8347C12.679 15.6003 12.3611 15.4686 12.0295 15.4686ZM12.0295 5.46863C11.698 5.46863 11.3801 5.60032 11.1457 5.83474C10.9112 6.06917 10.7795 6.38711 10.7795 6.71863V11.7186C10.7795 12.0501 10.9112 12.3681 11.1457 12.6025C11.3801 12.8369 11.698 12.9686 12.0295 12.9686C12.3611 12.9686 12.679 12.8369 12.9134 12.6025C13.1478 12.3681 13.2795 12.0501 13.2795 11.7186V6.71863C13.2795 6.38711 13.1478 6.06917 12.9134 5.83474C12.679 5.60032 12.3611 5.46863 12.0295 5.46863Z"
      fill="#FFFFFF"
    />
  </svg>
);

/* Consistent Icon */
export const ConsistentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={12.499} cy={12.692} r={12} fill="#F1F5F9" />
    <path
      fill="#000"
      d="M14.75 12.692c0-1.275-.976-2.25-2.25-2.25s-2.25.975-2.25 2.25.975 2.25 2.25 2.25 2.25-.975 2.25-2.25m1.5-6.525c-2.925-1.65-6.525-1.125-8.925 1.05V5.942c0-.45-.3-.75-.75-.75s-.75.3-.75.75v3.375c0 .45.3.75.75.75H9.95c.45 0 .75-.3.75-.75s-.3-.75-.75-.75h-1.8a5.96 5.96 0 0 1 4.35-1.875c3.3 0 6 2.7 6 6 0 .45.3.75.75.75s.75-.3.75-.75c0-2.7-1.425-5.175-3.75-6.525m2.174 9.15H15.05c-.45 0-.75.3-.75.75s.3.75.75.75h1.8a5.96 5.96 0 0 1-4.35 1.875c-3.3 0-6-2.7-6-6 0-.45-.3-.75-.75-.75s-.75.3-.75.75c0 4.125 3.375 7.5 7.5 7.5 1.95 0 3.75-.75 5.174-2.1v1.35c0 .45.3.75.75.75s.75-.3.75-.75v-3.375c0-.45-.375-.75-.75-.75"
    />
  </svg>
);

/* GreenCheckmarkFilled Icon */
export const GreenCheckmarkFilledIcon: FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx="12" cy="12" r="12" fill="#279559" />
    <path
      d="M16.4609 7.41537L10.0752 13.5575L7.61911 11.2006C7.48567 11.0511 7.32146 10.9297 7.13678 10.8439C6.95211 10.7582 6.75097 10.71 6.54597 10.7024C6.34097 10.6948 6.13655 10.728 5.94554 10.7998C5.75452 10.8716 5.58104 10.9805 5.43598 11.1197C5.29091 11.2589 5.1774 11.4254 5.10257 11.6087C5.02773 11.792 4.99319 11.9882 5.00111 12.1849C5.00903 12.3816 5.05924 12.5746 5.14858 12.7519C5.23793 12.9291 5.36448 13.0866 5.5203 13.2147L9.01831 16.5857C9.1574 16.7181 9.32235 16.8229 9.50371 16.8939C9.68507 16.965 9.87926 17.0011 10.0752 17C10.4657 16.9984 10.8399 16.8496 11.1171 16.5857L18.5597 9.44371C18.6992 9.31092 18.81 9.15293 18.8855 8.97887C18.9611 8.80481 19 8.6181 19 8.42954C19 8.24097 18.9611 8.05427 18.8855 7.88021C18.81 7.70614 18.6992 7.54816 18.5597 7.41537C18.2808 7.14933 17.9035 7 17.5103 7C17.1171 7 16.7398 7.14933 16.4609 7.41537Z"
      fill="white"
    />
  </svg>
);
